







































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { FixedTerm as FixedTermInterface } from "../../services/language/entities/fixed-term.interface";
import rules from "../../utils/rules";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component
export default class FixedTerm extends Vue {
  @Prop() term!: FixedTermInterface;
  @Prop() page!: number;

  generalRules = [rules.notEmpty];
  loadingUpdate = false;
  snackbarSuccessUpdate = false;
  snackbarErrorUpdate = false;
  valid = true;
  $refs!: {
    formUpdate: HTMLFormElement;
  };
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private updateTerm(): void {
    this.loadingUpdate = true;
    this.$store
      .dispatch("language/updateFixedTerm", {
        termName: this.term.termName,
        termTranslate: this.term.translate,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }

        this.loadingUpdate = false;
      });
  }
}
